import { ConversationContact } from "../dto/contact";

export function canOpenChatCTA(
  conversation: ConversationContact | null | undefined,
  operator: { id?: string | null; teamId?: string | null } | null | undefined
): boolean {
  if (!conversation) return true;

  const convoTeamId = conversation.teamId ?? null;
  const operatorTeamId = operator?.teamId ?? null;
  const operatorId = operator?.id ?? null;

  const isConvoWithoutTeam = !convoTeamId;

  const isSameTeam =
    !!convoTeamId && !!operatorTeamId && convoTeamId === operatorTeamId;

  const isAssignedOrLockedToMe =
    !!operatorId &&
    (conversation.operatorId === operatorId ||
      conversation.lockedByOperatorId === operatorId);

  // Regole:
  // - team uguali -> CTA
  // - convo senza team -> CTA
  // - assegnata/bloccata a me -> CTA
  // - altrimenti NO
  return isSameTeam || isConvoWithoutTeam || isAssignedOrLockedToMe;
}
